<template>
  <el-dropdown placement="bottom" size="small" @command="changeLocale">
    <el-button class="btn-text can-hover" type="text">
      <i class="fa fa-language"></i>
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="language in languages"
        :key="language.value"
        :command="language">
        <i :class="$i18n.locale === language.value ? 'fa fa-dot-circle-o' : 'fa fa-circle-o'"></i>
        {{ language.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
import { mapState } from 'vuex'
import localeMixin from '@/locales/mixin.js'
export default {
  mixins: [
    localeMixin
  ],
  computed: {
    ...mapState('admin/system', ['languages'])
  },
  methods: {
    changeLocale(locale) {
      this.onChangeLocale(locale)
      location.reload()
    }
  }
}
</script>